import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable ,  Subject } from 'rxjs';

@Injectable()
export class NotificationService {

  private globalErrorStream = new Subject<any>();
  globalErrors$ = this.globalErrorStream.asObservable();

  handleError(error: HttpErrorResponse): void {
    this.globalErrorStream.next(error);
  }

}
